import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-69" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-70" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-71" data-mp="32m1bayt2r0om">
          THE NUTRITIONIST’S VAULT<span className="align-super text-xs" data-id="element-72" data-mp="36nd57gize82m">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-73" data-mp="3ugbs3c3g5mlg">
          The visual method to manage a professional nutrition practice from absolute zero: clinical
          protocols, rapid meal planning, patient psychology and business scaling in 30 days.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-74" data-mp="3qcdsz1e4gbse">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="29ydxq3q81abh">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3l9acngdir03d" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="3gapb9dmj6adc">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3v7zuj95f0kjm" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-79" data-mp="3q7u23qrbmu0h">
          🏥 “Your professional practice starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-80" data-mp="33xchtnnhqqe">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-81" data-mp="hstsqdzv2a23">
            Terms & Conditions
          </a>
          <span data-id="element-82" data-mp="curzx1cmuwdf">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="cu8qk911tgb0">
            Privacy Policy
          </a>
          <span data-id="element-84" data-mp="mrwplb5ot9yz">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="msg5ynfovqaw">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-86" data-mp="two3psuwdf6s">
          © 2026 THE NUTRITIONIST’S VAULT™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}